/* eslint-disable no-unused-vars */
import React, { useContext } from 'react'
import { CollapseContext } from '../../../context/CollapseMenuContext'
import LeftMenuV2 from '../LeftMenuV2'
import './style.scss'

function Sidebar() {
  const { isCollapse } = useContext(CollapseContext)
  return (
    <aside className={`sidebar-container ${isCollapse ? 'is-collapse' : ''}`}>
      <LeftMenuV2 />
    </aside>
  )
}

export default Sidebar
